import { createUniqueId, onCleanup, onMount, type JSX, type ParentProps } from "solid-js";

interface ModalProps extends ParentProps {
  title: string;
  eyebrow?: string;
  onClose: () => void;
  footer?: JSX.Element;
  busy?: boolean;
  size?: "normal" | "wide";
}

export function Modal(props: ModalProps): JSX.Element {
  let dialog!: HTMLDialogElement;
  const titleID = createUniqueId();

  onMount(() => dialog.showModal());
  onCleanup(() => {
    if (dialog.open) dialog.close();
  });

  return (
    <dialog
      ref={dialog}
      class={`modal ${props.size === "wide" ? "modal--wide" : ""}`}
      aria-labelledby={titleID}
      onCancel={(event) => {
        event.preventDefault();
        if (!props.busy) props.onClose();
      }}
      onClick={(event) => {
        if (event.target === dialog && !props.busy) props.onClose();
      }}
    >
      <section class="modal__surface">
        <header class="modal__header">
          <div>
            {props.eyebrow ? <p class="eyebrow">{props.eyebrow}</p> : null}
            <h2 id={titleID}>{props.title}</h2>
          </div>
          <button
            class="icon-button"
            type="button"
            aria-label="关闭弹窗"
            disabled={props.busy}
            onClick={props.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>
        </header>
        <div class="modal__body">{props.children}</div>
        {props.footer ? <footer class="modal__footer">{props.footer}</footer> : null}
      </section>
    </dialog>
  );
}
